import CoreCompatibilityModal from 'marketplace-ui-common/compatibility/components/FeatureCompatibilityModal';
import { useCompatibility } from 'marketplace-ui-common/compatibility/hooks/useCompatibility';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated only for use with deprecated integrationFeatures
 */
export const LegacyFeatureCompatibilityModal = ({
  appContext,
  onClose,
  integrationFeatures,
  tierGroupNames,
  trackInteraction
}) => {
  const scopeFeatures = integrationFeatures.map(feature => ({
    text: feature.headline,
    scopes: feature.hubSpotFeatures
  }));
  const {
    compatibilityRequestState,
    featuresWithTierCompatibility,
    portalTiers
  } = useCompatibility({
    appContext,
    offeringType: 'APP',
    scopeFeatures,
    tierGroupNames
  });
  return /*#__PURE__*/_jsx(CoreCompatibilityModal, {
    appContext: appContext,
    featuresWithTierCompatibility: featuresWithTierCompatibility,
    offeringType: "APP",
    onClose: onClose,
    portalTiers: portalTiers,
    requestState: compatibilityRequestState,
    tierGroupNames: tierGroupNames,
    trackInteraction: trackInteraction
  });
};